import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-analysis-page-skeleton',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './analysis-page-skeleton.component.html',
  styleUrls: ['./analysis-page-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalysisPageSkeletonComponent {}
